import { type FC } from 'react';

interface Props {
	currentEntity: any;
	initialEntity: any;
	mapper: (_) => any;
}

const AttributesChanges: FC<Props> = (props) => {
	const { currentEntity, initialEntity, mapper } = props;

	const currentAttributes = mapper(currentEntity);
	const initAttributes = mapper(initialEntity);

	const attributesChanged = Object.keys(currentAttributes).filter(
		(key) => currentAttributes[key] !== initAttributes[key]
	).length;

	return (
		<div className={'changeTitle'}>
			{attributesChanged && (
				<div>
					{attributesChanged} attribute{attributesChanged > 1 ? 's' : ''} changed
				</div>
			)}
		</div>
	);
};

export default AttributesChanges;
